export class CustomerModel {
    customerCode: string;
    customerNumber: string;
    linkedDatetime: string;
    storeCode: string;
    storeName: string;
    commercial: string;
}

/* CustomersModelのステータス */
export const CUSTOMERS_MODEL_STATUS = {
    UNLOADED: 'unloaded',
    LOADED: 'loaded',
    ERROR: 'error'
} as const;
type CUSTOMERS_MODEL_STATUS = typeof CUSTOMERS_MODEL_STATUS[keyof typeof CUSTOMERS_MODEL_STATUS];

export class CustomersModel {
    status: CUSTOMERS_MODEL_STATUS = CUSTOMERS_MODEL_STATUS.UNLOADED;
    customers: Array<CustomerModel> = [];
}